import React, { useContext } from 'react'

import { withRouter, RouteComponentProps } from 'react-router-dom'

import useHistoryUrls from './use-history-urls'

interface TrackPreviousPageContextValue {
  historyUrls: string[]
  previousUrl: string
  isInitialPage: boolean
}

export const Context = React.createContext<TrackPreviousPageContextValue | null>(null)

export const usePreviousUrl = () => useContext(Context)?.previousUrl

interface Props extends RouteComponentProps {
  children: React.ReactNode
}

export const TrackPreviousPageProvider = ({ history, children }: Props) => {
  const historyUrls = useHistoryUrls(history)
  const previousUrl = historyUrls[historyUrls.length - 2] || historyUrls[0]
  const isInitialPage = previousUrl === ''
  return (
    <Context.Provider
      value={{
        historyUrls,
        previousUrl,
        isInitialPage,
      }}
    >
      {children}
    </Context.Provider>
  )
}

export default withRouter(TrackPreviousPageProvider)
